<template>
  <div>
    <top-bar :user="user" />
    <MenuItems :user="this.user" :menuSelected="{ terms: true }" />
    <div class="menu-mobile">
      <div class="user-mobile">
        <div class="close-menu" @click="openMenu(false)">
          <img src="@/assets/images/x.svg" />
        </div>
        <div class="openNotifications" @click="showModalPopup('modal_popup_mobileNotifications', true)">
          <div class="unread-notifications">
            <span>2</span>
          </div>
          <img src="@/assets/images/clopotel-alb.svg" />
        </div>

        <div id="modal_popup_mobileNotifications" class="modal-popup">
          <div class="modal-popup-content">
            <a @click="showModalPopup('modal_popup_mobileNotifications', false)" class="close-button">
              <img src="@/assets/images/close-button.svg" />
            </a>
            <div class="notifications">
              <!-- <NotificationsBox :notifications="this.companyMessages" /> -->
            </div>
          </div>
        </div>

        <div>
          <img src="@/assets/images/linie.png" />
        </div>
        <div>
          <img src="@/assets/images/settings.png" />
        </div>
        <div>
          <!-- <a href="#">{{ this.customer.name | titleCase }}</a> -->
        </div>
      </div>
      <MenuItems :user="this.user" :menuSelected="{ dashboard: true }" />
    </div>
    <div class="container-right ">
      <div :class="{
        content: true,
        'dashboard-beneficiary': true,
      }">
        <iframe id="iframe" class="content-iframe" :src="config.terms"></iframe>

      </div>
    </div>
  </div>
</template>

<script>
import TopBar from "../components/company/TopBar.vue";
import MenuItems from "../components/company/MenuItems.vue";

export default {
  name: "Terms",
  components: { TopBar, MenuItems },
  data() {
    return {
      user: null,
      config: JSON.parse(sessionStorage.getItem("club_jsonFile")),

    };
  },
  created() {
    this.user = this.getUser();
  },
};
</script>
<style scoped src="@/assets/styles/beneficiary.css">

</style>
<style scoped>
.content-iframe body {
  padding: 10px;
  background: #fff;
  
}

.content-iframe body::-webkit-scrollbar {
	-webkit-appearance: none;
	appearance: none;
	width: 0px;
}
.content-iframe {
  width: 100%;
  margin: 0;
  padding: 0;
  border: none;
  height: calc(100vh - 104px);
  overflow-y: hidden !important;  
  
}
@media (max-width: 1003px) {
  .content-iframe {
    display: block;
    margin: 0 auto;
  }
}
</style>

